module.exports = __webpack_public_path__ + "f27ae1eae0f22cf3cb37e46611dcd408.svg";